import { BrowserRouter as Router } from 'react-router-dom';
import Routing from './routes/index';
import './assets/css/bootstrap.min.css';
import './assets/fonts/flaticon/flaticon_ecommerce.css';
import './vendor/slick/css/slick.css';
import './vendor/slick/css/slick-theme.css';
import './assets/css/style_2.css';
import './assets/css/style_3.css';
import './assets/css/style_4.css';
import './assets/css/style_5.css';
import './assets/css/style_6.css';
import './assets/css/style_7.css';
import './assets/css/style.css';


const App = () => {
  return (
    <>
      <Router basename='/offex'>
        <Routing />
      </Router>
    </>
  )
}

export default App
